const HOST = __ENDPOINT_URL__;
export const PANDA_KEY = __PANDA_KEY__;
export const PANDA_JS = __PANDA_SCRIPT__;
export const TOGGLE_MENU = "TOGGLE_MENU";
export const HTTP_REQUEST = "HTTP_REQUEST";
export const HTTP_SUCCESS = "HTTP_SUCCESS";
export const HTTP_ERROR = "HTTP_ERROR";

export const SUBMIT_URL = `${HOST}/api/payment`;
export const FEATURED_URL = `${HOST}/api/featured/data.json`;
export const RESPONSE_URL = `${HOST}/api/response/`;
export const FEEDBACK_URL = `${HOST}/api/feedback`;
export const TRACK_URL = `${HOST}/api/track.json`;
export const ZIP_URL = "//zip.getziptastic.com/v2/US/";
export const DONATION_URL = "http://zip.getziptastic.com/v2/US/";
export const FEATURED_REQUEST_INIT = "FEATURED_REQUEST_INIT";
export const FEATURED_REQUEST_SUCCESS = "FEATURED_REQUEST_SUCCESS";
export const FEATURED_REQUEST_ERROR = "FEATURED_REQUEST_ERROR";
export const SELECT_CHARITY = "SELECT_CHARITY";
export const DETAILS_ADD_FIELD = "DETAILS_ADD_FIELD";
export const DETAILS_DELETE_FIELD = "DETAILS_DELETE_FIELD";
export const DETAILS_ONCHANGE = "DETAILS_ONCHANGE";
export const DETAILS_ONBLUR = "DETAILS_ONBLUR";
export const MESSAGE_ONCHANGE = "MESSAGE_ONCHANGE";
export const PAYMENT_ONCHANGE = "PAYMENT_ONCHANGE";
export const PAYMENT_ONBLUR = "PAYMENT_ONBLUR";
export const DONATION_REQUEST_INIT = "DONATION_REQUEST_INIT";
export const DONATION_REQUEST_SUCCESS = "DONATION_REQUEST_SUCCESS";
export const DONATION_REQUEST_ERROR = "DONATION_REQUEST_ERROR";
export const RESET_GLOBAL_STATE = "RESET_GLOBAL_STATE";
export const DEFAULT_AMOUNT = 10;
export const DEFAULT_RETURN_AMOUNT = 10;
export const RESPONSE_FETCH_REQUEST = "RESPONSE_FETCH_REQUEST";
export const RESPONSE_FETCH_SUCCESS = "RESPONSE_FETCH_SUCCESS";
export const RESPONSE_FETCH_ERROR = "RESPONSE_FETCH_ERROR";
export const FEEDBACK_REQUEST = "FEEDBACK_REQUEST";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_ERROR = "FEEDBACK_ERROR";



// WEBPACK FOOTER //
// ./constants/constants.js